import type { ReactNode } from "react";
import { Link } from "react-router-dom";
import { useAuthState } from "../auth/AuthContext";
import { signOutCurrentUser } from "../auth/firebaseAuth";

export function Layout({ children }: { children: ReactNode }) {
  const auth = useAuthState();

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <header
        style={{
          backgroundColor: "var(--color-surface)",
          borderBottom: "1px solid var(--color-border)",
          padding: "var(--space-4) var(--space-5)",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Link
          to="/"
          style={{
            fontWeight: 700,
            fontSize: "1.1rem",
            color: "var(--color-primary)",
            textDecoration: "none",
          }}
        >
          Berry Buds
        </Link>
        {auth.status === "authenticated" ? (
          <button
            type="button"
            onClick={() => {
              void signOutCurrentUser();
            }}
            style={{
              backgroundColor: "transparent",
              color: "var(--color-text-sub)",
              border: "1px solid var(--color-border)",
              borderRadius: "var(--radius-sm)",
              padding: "var(--space-2) var(--space-3)",
              cursor: "pointer",
            }}
          >
            ログアウト
          </button>
        ) : null}
      </header>
      <main
        style={{
          flex: 1,
          padding: "var(--space-5)",
          maxWidth: 720,
          margin: "0 auto",
          width: "100%",
        }}
      >
        {children}
      </main>
      <footer
        style={{
          padding: "var(--space-4) var(--space-5)",
          color: "var(--color-text-sub)",
          fontSize: "0.85rem",
          textAlign: "center",
        }}
      >
        © Berry Buds
      </footer>
    </div>
  );
}
